import React, { useState } from "react";
import "./gallery.css";

const Gallery = () => {
  const images = [];
  for (let i = 1; i <= 49; i++) {
    images.push(`${process.env.PUBLIC_URL}/images/img${i}.jpeg`);
  }

  const certificates = [];
  for (let i = 1; i <= 7; i++) {
    certificates.push(`${process.env.PUBLIC_URL}/images/ph${i}.jpeg`);
  }

  const [popupOpen, setPopupOpen] = useState(false);
  const [popupImages, setPopupImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openPopup = (imgs, index) => {
    setPopupImages(imgs);
    setCurrentIndex(index);
    setPopupOpen(true);
  };

  const closePopup = () => setPopupOpen(false);

  const prevImg = () =>
    setCurrentIndex((prev) =>
      prev === 0 ? popupImages.length - 1 : prev - 1
    );

  const nextImg = () =>
    setCurrentIndex((prev) =>
      prev === popupImages.length - 1 ? 0 : prev + 1
    );

  return (
    <div className="gallery-container">
      <h2 className="gallery-title">📸 गावाचा विकास – छायाचित्रांतून</h2>

      {/* Certificate Button */}
      <div className="certificate-btn-box">
        <button
          className="certificate-btn"
          onClick={() => openPopup(certificates, 0)}
        >
          📜 प्रमाणपत्रे पहा
        </button>
      </div>

      {/* Main Gallery */}
      <div className="gallery-grid">
        {images.map((src, index) => (
          <div
            className="gallery-card"
            key={index}
            onClick={() => openPopup(images, index)}
          >
            <img src={src} alt={`Gallery ${index + 1}`} />
          </div>
        ))}
      </div>

      {/* Popup Modal */}
      {popupOpen && (
        <div className="popup-overlay">
          <span className="close-btn" onClick={closePopup}>
            ✕
          </span>

          <span className="nav-btn left" onClick={prevImg}>
            ❮
          </span>

          <img
            src={popupImages[currentIndex]}
            alt="popup"
            className="popup-img"
          />

          <span className="nav-btn right" onClick={nextImg}>
            ❯
          </span>
        </div>
      )}
    </div>
  );
};

export default Gallery;
